<script setup lang="ts">
defineProps<{
  name: string
  placeholder?: string
  label?: string
  maxlength?: number
}>();

const modelValue = defineModel<string>();
</script>

<template>
  <div>
    <IadLabel
      :html-for="name"
      :text="label"
    />
    <textarea
      :id="name"
      v-model="modelValue"
      :name
      rows="5"
      class="border border-neutral focus:border-secondary outline-none
          placeholder:text-neutral placeholder:font-medium
          block w-full px-s py-xs rounded-md"
      :placeholder
      :maxlength
    />
  </div>
</template>
